<template lang="html">
  <div class="transfer-customers">
    <Navbar />
    <div class="content-i">
      <div class="content-box" style="padding-top: 20px;">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-info">
              <p class="col-12 px-0 acknowledge-top">
                {{ t('messageAcknowledgeStatusHeader', 'messageAcknowledgeStatusHeader') }}
              </p>
              <div class="col-12 px-0">
                <div class="col-12 px-0" v-if="!ref">{{ t('tsArgumentNotProvided', 'tsArgumentNotProvided') }}</div>
                <div class="col-12 px-0" v-if="!ts">{{ t('refArgumentNotProvided', 'refArgumentNotProvided') }}</div>
              </div>
              <div class="col-12 px-0" v-if="responseMsg">
                {{ t(responseMsg, responseMsg) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'acknowledge_msg',
  components: {
    ResponseInfo,
    Navbar
  },
  data() {
    return {
      ref: null,
      ts: null,
      responseMsg: null
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),

  },
  methods: {
    acknowledgeMsg() {
      this.$store.dispatch('documentsStore/acknowledgeMsg', {
        ts: this.ts,
        ref: this.ref
      }, this).then(response => {
        if(response.key) {
          this.responseMsg = response.key
        }
      })
    }
  },
  created() {
    this.ref = this.$route.query.ref
    this.ts = this.$route.query.ts
    if(this.ref && this.ts) {
      this.acknowledgeMsg()
    }
    
  }
}
</script>

<style lang="css" scoped>
  .acknowledge-top {
    font-weight: 600;
    font-size: 26px;
  }
</style>
